export enum ConfirmationTypeEnum {
  LOAN = 'LOAN',
  COUNTER = 'COUNTER',
  SALE = 'SALE',
  BUY = 'BUY',
  BID = 'BID',
  ACCEPT_BID = 'ACCEPT_BID',
  REPAY = 'REPAY',
  RESALE = 'RESALE',
  REFINANCE = 'REFINANCE',
  RESALE_COUNTER = 'RESALE_COUNTER',
  FORECLOSE = 'FORECLOSE',
  CANCEL = 'CANCEL',
  TRANSFER_NFT = 'TRANSFER_NFT',
  OFFER_LOAN = 'OFFER_LOAN',
}